module.exports = __webpack_public_path__ + "static/tr-section-6@2x-e154edba0ca734678b16e04ad752f493.png";